/*
 * Note: when using as url defined in model declared prior to viewer load (settings.pathtoapi is not set), ensure the BB url is a function
 * Note: not including ES search and Feith Libs endpoints -- they have a different path to API, now in settings
 *
 */

var _ = require('underscore');


var ApiURL = function(pathToApi) {

    var o = {};

    for (var k in this.prototype) {

        var val = this.prototype[k];

        o[k] = typeof val === 'string'
            ? pathToApi + val
            : (function(val) {
                return function() {
                    var args = Array.prototype.slice.apply(arguments);
                    return pathToApi + val.apply(this, args);
                };
            })(val);
        }

    this.constructor.prototype = o;

    return o;

};


_.extend( ApiURL.prototype, {

    /* Global */

    login: 'auth/login',
    logout: 'auth/logout',
    keepAlive: 'auth/keepAlive', //  //?verbose=' + verbose,  //verbose = true returns with data
    unauthorizedData: 'auth/unauthorizedData',
    systemPolicies: 'system/policies',
    feithLibraryVersionInfo: 'versionInfo',

    user: 'user',
    userGroups: 'user/groups',
    allPrivateGroups: 'user/allPrivateGroups',
    taskPerms:'user/taskPerms',
    referralGroups: 'user/referralGroups',
    myStamps: 'myStamps',

    reasonCodes: 'system/reasonCodes',

    /* Instance - some Document Dependent  */
    docInfo: 'document/info',

    // No Longer Used to Fetch though used as the basis for doc note model operations.
    docNotes: function( docModel ) {
        return 'document/' + docModel.getContainerType() + '/' + docModel.getContainerId() +
            '/' + docModel.getId() + '/notes';
    },

    pageNotes: 'document/pageNotes', // ( this is the POST; there is also a GET; neither is used )

    // Not used as get, though the base for pageNote Operations
    pageNote: function(docModel, pgId, seq) {

        var baseGetUrl = 'page/' + docModel.getContainerType() + '/' + docModel.getContainerId() +
            '/' + docModel.getId() + '/' + pgId + '/notes';

        return baseGetUrl + (seq ? '/' + seq : '');

    },
    // This is the endpoint for the post of the document resource; other is a get

    rotatePage: function(docModel, pgId, deg) {
        return 'page/' + docModel.getContainerType() + '/' + docModel.getContainerId() + '/' + docModel.getId() + '/' + pgId + '/rotate?rotation=' + deg;
    },
    deletePages: function(docModel) {
        //TODO: common with rotate page -- make fn on model the base uri ...
        return 'document/' + docModel.getContainerType() + '/' + docModel.getContainerId() + '/' + docModel.getId() + '/' + 'deletePages';
    },
    addPages: function(docModel, insertAtPgNum) {

        //TODO: common with rotate page -- make fn on model the base uri ...
        var url = 'document/' + docModel.getContainerType() + '/' + docModel.getContainerId() + '/' + docModel.getId() + '/' + 'addPages';

        // API really wants page #, but providing sequence here for this application
        // ( eg pages could be provided individually in doc request ).
        // If insertAtPgNum isn't provided, page will be appended to the end of the document.
        // if there are no pages, append to the end, this won't mean anything; (could disabled in UI for page selection)

        if (insertAtPgNum && !docModel.get('docHasNoPages'))
            url += '?sequence=' + docModel.pageCollection.findWhere({ number: insertAtPgNum }).get('seq');

        return url;
    },
    reorderPages: function(docModel) {
        return 'document/' + docModel.getContainerType() + '/' + docModel.getContainerId() + '/' + docModel.getId() + '/reorderPages';
    },
    multiPartGosPageDownload: function( docModel, page ) {
        return 'page/' + docModel.getContainerType() + '/' + docModel.getContainerId() + '/' + docModel.getId() +
            '/' + page.get('pageId') + '/download/large';
    },
    lockStatus: function( docModel ) {
        return 'document/' + docModel.getContainerType() + '/' + docModel.getContainerId() + '/' + docModel.getId() + '/lock/status';
    },
    lockDocument: function( docModel ) {
        return 'document/' + docModel.getContainerType() + '/' + docModel.getContainerId() + '/' + docModel.getId() + '/lock';
    },
    unlockDocument: function( docModel, force ) {
        var url = 'document/' + docModel.getContainerType() + '/' + docModel.getContainerId() + '/' + docModel.getId() + '/unlock';
        if (force)
            url += '?force=true';
        return url;
    },

    /**
     * Note: allowDownload and allowPrint now only applicable to test server
     * ( they are determine at the server level so user can't change via URL )
     */
    pdfJsViewer: function( creUrl, allowDownload, allowPrint, isNode ) {

        var src;

        /**
         * Could just pass in imgUrl from creResponse but may want inline=true in the future.
         * Inline URL can be a flag for the node server ...
         * Getting rid of it also makes it easier to apply hash parameters.
         */
        creUrl = creUrl.replace('?inline=true', '');

        if (isNode) {

            src = '/api/pdfviewer?file=' + creUrl;

            // Note: current forked pdf-js viewer will also want these params,
            // but for now not using it
            if ( !allowDownload )
                src += '&disableDownload=1';

            if ( !allowPrint )
                src += '&disablePrint=1';

        } else {

            var PATH_TO_VIEWER_HTML = 'pdfjsViewer/web/viewer.html';
            src = PATH_TO_VIEWER_HTML;
            src += '?file=' + creUrl;

        }

        /**
         * Hash parameters must come after the file query parameter ( and others if sent )
         * Enforce the first page ( unsure if we want this )
         * For now leave to make consistent with other PDF viewers.
         * Should check hash alogorythm used to store PDF files in PDF.js's local history
         * ( the CRE file names will change so may not be applicable )
         */
        src += '#page=1';

        return src;

    }

});


module.exports = ApiURL;








/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/FV/apiUrl.js
 ** module id = 762
 ** module chunks = 0
 **/